// extracted by mini-css-extract-plugin
export default {"container":"DuplicateLoad_container__pRTj1"};